//Generated File 
export const Always = `Always`;
export const Never = `Never`;
export const WhenNotPublic = `WhenNotPublic`;
